const responseStatusActions = {
    types: {
        RESPONSE_STATUS_SET_LAST_SAVED: 'RESPONSE_STATUS_SET_LAST_SAVED',
        RESPONSE_STATUS_SET_REPLIED_TO: 'RESPONSE_STATUS_SET_REPLIED_TO',
    },

    setLastSaved(contentRevisionId, dateStamp) {
        if (typeof contentRevisionId !== 'number' || typeof dateStamp !== 'string') {
            throw new Error('Incorrect param types.');
        }
        return { type: this.types.RESPONSE_STATUS_SET_LAST_SAVED, contentRevisionId, dateStamp };
    },

    setReplyStatus(contentRevisionId, repliedTo, allDeclarationsRepliedTo) {
        return {
            allDeclarationsRepliedTo,
            contentRevisionId,
            repliedTo,
            type: this.types.RESPONSE_STATUS_SET_REPLIED_TO,
        };
    },
};

export default responseStatusActions;
